import { IDimension } from "../../scroll/perfectScrollModel";
import { setOffsetsOnScrollAT } from "./SetOffsetsOnScrollModel";

const typeKeys = {
    x: {
        containerMeasure: "containerWidth",
        contentMeasure: "contentWidth",
        scrollMeasure: "scrollLeft",
    },
    y: {
        containerMeasure: "containerHeight",
        contentMeasure: "contentHeight",
        scrollMeasure: "scrollTop",
    },
};

export const buildSetOffsetsOnScrollReducer = type => (
    state: IDimension = null,
    action
) => {
    switch (action.type) {
        case setOffsetsOnScrollAT.setUp:
            return {
                containerMeasure: action[typeKeys[type].containerMeasure],
                contentMeasure: action[typeKeys[type].contentMeasure],
                scrollMeasure: action[typeKeys[type].scrollMeasure],
            };

        case setOffsetsOnScrollAT.update:
            const newScroll = action[typeKeys[type].scrollMeasure];
            if (!Number.isFinite(newScroll)) return state;

            const maxScroll = state.contentMeasure - state.containerMeasure;
            return {
                ...state,
                scrollMeasure:
                    newScroll < 0
                        ? 0
                        : newScroll > maxScroll
                        ? maxScroll
                        : newScroll,
            };

        default:
            return state;
    }
};
